import { FC, useEffect, useState } from "react";
import { Button, Container, Nav, NavItem } from "reactstrap";
import { ShowcaseOfSuccess } from "../../../constants";
import { PortfolioListData } from "../../../data/pages/Portfolio";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { setCardToShow } from "../../../reduxToolkit/reducers/layoutSlice";
import { routes } from "../../../routers/routes";
import { PortfolioType } from "../../../types/Portfolio";
import Breadcrumbs from "../breadcrumbs";
import PortfolioBox from "./PortfolioBox";

const Portfolio: FC<PortfolioType> = ({ gridSize, carShow, type, sectionClass }) => {
  const [activeTab, setActiveTab] = useState("all");
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setCardToShow(carShow || 6));
  }, [carShow, dispatch]);
  return (
    <>
      <Breadcrumbs title="Portfolio" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <section className={`portfolio-section section-b-space ${sectionClass ? sectionClass : ""}`}>
        <Container>
          <h3>{ShowcaseOfSuccess}</h3>
          {type !== "box_slider" && (
            <div className="nav-tabs-portfolio">
              <Nav pills>
                {PortfolioListData.map((item, index) => (
                  <NavItem key={index}>
                    <Button className={`nav-link tab-filter ${activeTab === item.type ? "active" : ""}`} color="transparent" onClick={() => setActiveTab(item.type)}>
                      {item.title}
                    </Button>
                  </NavItem>
                ))}
              </Nav>
            </div>
          )}
          <PortfolioBox activeTab={activeTab} gridSize={gridSize} type={type} />
        </Container>
      </section>
    </>
  );
};

export default Portfolio;
